export function parseJobDetails(value) {
    if (value === '') {
        return [];
    }
    return value.split('&&').map(pair => {
        const separatorIndex = pair.indexOf(':');
        if (separatorIndex === -1) {
            return {
                fieldKey: pair,
                fieldValue: ''
            };
        }
        return {
            fieldKey: pair.substring(0, separatorIndex),
            fieldValue: pair.substring(separatorIndex + 1)
        };
    });
}

export function serializeJobDetails(rows) {
    return rows
        .filter(row => row.fieldKey !== '' || row.fieldValue !== '')
        .map(row => row.fieldKey + ':' + row.fieldValue)
        .join('&&');
}
